import { OrderInQueue } from 'app/models/orderInQueue.model';
import { OrderStatus } from 'app/models/orderStatus.model';

/** Сколько заказ может пробыть в NEW после получения хабом, прежде чем считается зависшим (IC-3009). */
export const STUCK_IN_NEW_THRESHOLD_MS = 60 * 60 * 1000;

/**
 * Момент получения заказа хабом в UTC-миллисекундах. Хаб отдаёт discoveredAt без признака зоны,
 * поэтому пересчёт тот же, что в OrdersState.convertOrder. У заказов, открытых по прямой ссылке
 * (order/details/:id), discoveredAtUTC не посчитан — тогда считаем из discoveredAt.
 */
export function getDiscoveredAtUtcMs(order: Pick<OrderInQueue, 'discoveredAt' | 'discoveredAtUTC'>): number {
  if (typeof order.discoveredAtUTC === 'number') {
    return order.discoveredAtUTC;
  }
  return new Date(order.discoveredAt).getTime() - new Date().getTimezoneOffset() * 60000;
}

/** Заказ всё ещё в NEW, хотя с момента получения хабом прошёл час и больше. */
export function isOrderStuckInNew(
  order: Pick<OrderInQueue, 'orderStatus' | 'discoveredAt' | 'discoveredAtUTC'> | null,
  now: number = Date.now()
): boolean {
  if (!order || (order.orderStatus & OrderStatus.FILTER_STATE) !== OrderStatus.NEW) {
    return false;
  }
  const discoveredAt = getDiscoveredAtUtcMs(order);
  return !Number.isNaN(discoveredAt) && now - discoveredAt >= STUCK_IN_NEW_THRESHOLD_MS;
}
